<template>


  <div style="flex: 1;">
    <!-- <h1>主页</h1> -->

    <!-- <highcharts :options="chartOptions"></highcharts> -->

    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>数据</span>

      </div>


      <div>


        <div class="row-no-full" style="margin: 0 80px;padding: 10px 0;justify-content: space-between;">

          <div class="row-no-full">


            <div>
              <svg t="1599543233092" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
                p-id="1433" width="80" height="80">
                <path d="M958.027711 260.416617l-41.485825 23.450064c39.127119 69.230401 59.80749 148.116009 59.80749 228.133319 0 256.044672-208.31066 464.349376-464.349376 464.349376C255.955328 976.34342 47.650624 768.038716 47.650624 511.994044 47.650624 255.955328 255.955328 47.650624 512 47.650624c92.561337 0 181.936039 27.148943 258.456985 78.516316l26.559267-39.567887C712.609128 29.942461 614.055724 0 512 0 229.681965 0 0 229.681965 0 511.994044c0 282.318035 229.681965 512 512 512 282.312079 0 512-229.681965 512-512 0-88.213218-22.812736-175.205389-65.972289-251.577427z"
                  fill="#1296db" p-id="1434"></path>
                <path d="M216.45296 783.715771h47.650624c0-136.691772 111.204644-247.896416 247.896416-247.896415 136.685815 0 247.890459 111.204644 247.890459 247.896415h47.650625c0-128.27548-82.167545-237.675357-196.612432-278.458334 46.370014-31.687665 76.878326-84.961063 76.878326-145.239103 0-96.939238-78.861783-175.801021-175.806978-175.801021-96.939238 0-175.806978 78.861783-175.806978 175.801021 0 60.27804 30.508312 113.551437 76.878326 145.239103-114.450843 40.782978-196.618388 150.182855-196.618388 278.458334z m167.390686-423.697437c0-70.659919 57.490478-128.150397 128.156354-128.150397 70.659919 0 128.156354 57.490478 128.156354 128.150397 0 70.665876-57.490478 128.156354-128.156354 128.156354-70.665876-0.005956-128.156354-57.490478-128.156354-128.156354z"
                  fill="#1296db" p-id="1435"></path>
              </svg>
            </div>

            <div style="margin-left: 20px;" class="data-m">
              <div class="font-size-small">今日访问量</div>
              <div class="font-size-huge blod">{{top_data.today_access}}</div>
              <div class="font-size-small">昨日:{{top_data.yesterday_access}}</div>

            </div>


          </div>


          <div class="row-no-full">


            <div>
              <svg t="1599545096434" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
                p-id="3787" width="80" height="80">
                <path d="M512 64C264.576 64 64 264.577 64 512s200.576 448 448 448 448-200.576 448-448S759.424 64 512 64zM512 896c-212.078 0-384-171.923-384-384 0-212.077 171.922-384 384-384 212.077 0 384 171.923 384 384C896 724.077 724.077 896 512 896z"
                  p-id="3788" fill="#ca5828"></path>
                <path d="M352 256c-17.673 0-32 14.327-32 32l0 448c0 17.674 14.327 32 32 32s32-14.326 32-32L384 288C384 270.327 369.673 256 352 256z"
                  p-id="3789" fill="#ca5828"></path>
                <path d="M608 256 480 256c-17.673 0-32 14.326-32 32l0 448c0 17.674 14.327 32 32 32s32-14.326 32-32L512 576l96 0c88.366 0 160-71.635 160-160C768 327.634 696.366 256 608 256zM608 512l-96 0L512 320l96 0c53.02 0 96 42.98 96 96S661.02 512 608 512z"
                  p-id="3790" fill="#ca5828"></path>
              </svg>
            </div>

            <div style="margin-left: 20px;" class="data-m">
              <div class="font-size-small">今日Ip</div>
              <div class="font-size-huge blod">{{top_data.today_ip}}</div>
              <div class="font-size-small">昨日:{{top_data.yesterday_ip}}</div>

            </div>


          </div>


          <div class="row-no-full">


            <div>
              <svg t="1599547001058" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
                p-id="5515" width="80" height="80">
                <path d="M673.9 736.2c-13.7 0-26.9-7.6-33.4-20.6-9.2-18.4-1.7-40.9 16.7-50.1l99.6-49.8c18.4-9.2 40.9-1.8 50.1 16.7 9.2 18.4 1.7 40.9-16.7 50.1l-99.6 49.8c-5.4 2.6-11.1 3.9-16.7 3.9zM673.9 586.8c-13.7 0-26.9-7.6-33.4-20.6-9.2-18.4-1.7-40.9 16.7-50.1l99.6-49.8c18.4-9.2 40.9-1.7 50.1 16.7 9.2 18.4 1.7 40.9-16.7 50.1l-99.6 49.8c-5.4 2.6-11.1 3.9-16.7 3.9zM673.9 437.5c-13.7 0-26.9-7.6-33.4-20.6-9.2-18.4-1.7-40.9 16.7-50.1l99.6-49.8c18.4-9.2 40.9-1.8 50.1 16.7 9.2 18.4 1.7 40.9-16.7 50.1l-99.6 49.8c-5.4 2.6-11.1 3.9-16.7 3.9zM362.7 723.7c-5.6 0-11.3-1.3-16.7-3.9L246.5 670c-18.4-9.2-25.9-31.6-16.7-50.1 9.2-18.4 31.7-25.9 50.1-16.7l99.6 49.8c18.4 9.2 25.9 31.6 16.7 50.1-6.6 13-19.8 20.6-33.5 20.6zM362.7 574.4c-5.6 0-11.3-1.3-16.7-3.9l-99.6-49.8c-18.4-9.2-25.9-31.6-16.7-50.1 9.2-18.4 31.7-25.9 50.1-16.7l99.6 49.8c18.4 9.2 25.9 31.6 16.7 50.1-6.5 13-19.7 20.6-33.4 20.6zM362.7 425c-5.6 0-11.3-1.3-16.7-3.9l-99.6-49.8c-18.4-9.2-25.9-31.6-16.7-50.1 9.2-18.4 31.7-25.9 50.1-16.7l99.6 49.8c18.4 9.2 25.9 31.6 16.7 50.1-6.5 13-19.7 20.6-33.4 20.6z"
                  fill="#29CCB6" p-id="5516"></path>
                <path d="M512.1 985.1c-10.5 0-20.8-3.3-29.5-9.7-12.8-9.4-20.3-24.3-20.3-40.1V213.4c0-21.8 14.1-41 34.9-47.5L895.5 41.4c15.1-4.7 31.6-2 44.3 7.4 12.8 9.4 20.3 24.3 20.3 40.1v721.9c0 21.8-14.1 41-34.9 47.5L526.9 982.8c-4.8 1.5-9.8 2.3-14.8 2.3zM561.9 250v617.5l298.7-93.3V156.7L561.9 250z"
                  fill="#4585F5" p-id="5517"></path>
                <path d="M512.1 985.1c-5 0-10-0.8-14.9-2.3L99 858.3c-20.8-6.4-35-25.7-35-47.5V89c0-15.8 7.5-30.7 20.3-40.1 12.8-9.4 29.2-12.1 44.3-7.4L526.9 166c20.8 6.5 34.9 25.7 34.9 47.5v721.9c0 15.8-7.5 30.7-20.3 40.1a49.7 49.7 0 0 1-29.4 9.6zM163.6 774.2l298.7 93.3V250l-298.7-93.3v617.5z"
                  fill="#4585F5" p-id="5518"></path>
              </svg>
            </div>

            <div style="margin-left: 20px;" class="data-m">
              <div class="font-size-small">今日文章发布</div>
              <div class="font-size-huge blod">{{top_data.today_article}}</div>
              <div class="font-size-small">昨日:{{top_data.yesterday_article}}</div>

            </div>


          </div>



          <div class="row-no-full">


            <div>
              <svg t="1599547249479" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
                p-id="6324" width="80" height="80">
                <path d="M202.105263 835.368421v67.368421h619.789474V835.368421h80.842105v148.210526h-781.473684V835.368421c0-215.794526 174.942316-390.736842 390.736842-390.736842 35.139368 0 69.685895 4.634947 102.992842 13.743158l-21.288421 77.985684A310.298947 310.298947 0 0 0 512 525.473684c-171.142737 0-309.894737 138.752-309.894737 309.894737zM512 323.368421a107.789474 107.789474 0 1 0 0-215.578947 107.789474 107.789474 0 0 0 0 215.578947z m0 80.842105a188.631579 188.631579 0 1 1 0-377.263158 188.631579 188.631579 0 0 1 0 377.263158z m215.578947 188.631579v-107.789473h80.842106v107.789473h107.789473v80.842106h-107.789473v107.789473h-80.842106v-107.789473h-107.789473v-80.842106h107.789473z"
                  fill="#da4d3b" p-id="6325"></path>
              </svg>
            </div>

            <div style="margin-left: 20px;" class="data-m">
              <div class="font-size-small">今日注册</div>
              <div class="font-size-huge blod">{{top_data.today_user}}</div>
              <div class="font-size-small">昨日:{{top_data.yesterday_user}}</div>

            </div>


          </div>







        </div>




      </div>



    </el-card>


    <el-card class="box-card" style="margin-top: 20px;">
      <div slot="header" class="clearfix">
        <span>今日访问</span>

      </div>

      <div>

        <highcharts :options="access_option"></highcharts>

        <!-- <highcharts :options="chartOptions"></highcharts> -->

      </div>

    </el-card>


<!--    <el-card class="box-card" style="margin-top: 20px;">
      <div slot="header" class="clearfix">
        <span>30天内访问</span>

      </div>

      <div>

        <highcharts :options="access_option_month"></highcharts>

        

      </div>

    </el-card> -->




  </div>

</template>

<script>
  import Highcharts from 'highcharts'

  export default {
    name: "Home",
    data() {

      return {

        chartOptions: {
          series: [{
            data: [1, 2, 3] // sample data
          }]
        },

        access_option: {
          chart: {
            zoomType: 'x'
          },
          title: {
            text: '今日实时访问量'
          },
          subtitle: {
            text: document.ontouchstart === undefined ?
              '鼠标拖动可以进行缩放' : '手势操作进行缩放'
          },
          xAxis: {
            // type: 'datetime',
            // dateTimeLabelFormats: {
            //   millisecond: '%H:%M:%S.%L',
            //   second: '%H:%M:%S',
            //   minute: '%H:%M',
            //   hour: '%H:%M',
            //   day: '%m-%d',
            //   week: '%m-%d',
            //   month: '%Y-%m',
            //   year: '%Y'
            // }
            categories: [
              '00:00',
              "1:00",
              "2:00",
              '3:00',
              "4:00",
              "5:00",
              "6:00",
              "7:00",
              "8:00",
              "9:00",
              "10:00",
              "11:00",
              "12:00",
              "13:00",
              "14:00",
              "15:00",
              "16:00",
              "17:00",
              "18:00",
              "19:00",
              "20:00",
              "21:00",
              "22:00",
              "23:00",

            ],
            // minRange: 1,
            title: {
              text: '时间'
            }


          },
          tooltip: {
            // dateTimeLabelFormats: {
            //   millisecond: '%H:%M:%S.%L',
            //   second: '%H:%M:%S',
            //   minute: '%H:%M',
            //   hour: '%H:%M',
            //   day: '%Y-%m-%d',
            //   week: '%m-%d',
            //   month: '%Y-%m',
            //   year: '%Y'
            // }
          },
          yAxis: {
            title: {
              text: '访问'
            }
          },
          legend: {
            enabled: false
          },
          plotOptions: {
            area: {
              fillColor: {
                linearGradient: {
                  x1: 0,
                  y1: 0,
                  x2: 0,
                  y2: 1
                },
                stops: [
                  [0, new Highcharts.getOptions().colors[0]],
                  [1, new Highcharts.Color(Highcharts.getOptions().colors[0]).setOpacity(0).get('rgba')]
                ]
              },
              marker: {
                radius: 2
              },
              lineWidth: 1,
              states: {
                hover: {
                  lineWidth: 1
                }
              },
              threshold: null
            }
          },
          series: [{
            type: 'area',
            name: '实时访问',
            data: [
              ['0:00', 50],



            ]
          }]
        },

        access_option_month: {
          chart: {
            zoomType: 'x'
          },
          title: {
            text: '30天内访问量'
          },
          subtitle: {
            text: document.ontouchstart === undefined ?
              '鼠标拖动可以进行缩放' : '手势操作进行缩放'
          },
          xAxis: {
            // type: 'datetime',
            // dateTimeLabelFormats: {
            //   millisecond: '%H:%M:%S.%L',
            //   second: '%H:%M:%S',
            //   minute: '%H:%M',
            //   hour: '%H:%M',
            //   day: '%m-%d',
            //   week: '%m-%d',
            //   month: '%Y-%m',
            //   year: '%Y'
            // }
            categories: [
              '00:00',
              "1:00",
              "2:00",
              '3:00',
              "4:00",
              "5:00",
              "6:00",
              "7:00",
              "8:00",
              "9:00",
              "10:00",
              "11:00",
              "12:00",
              "13:00",
              "14:00",
              "15:00",
              "16:00",
              "17:00",
              "18:00",
              "19:00",
              "20:00",
              "21:00",
              "22:00",
              "23:00",

            ],
            // minRange: 1,
            title: {
              text: '时间'
            }


          },
          tooltip: {
            // dateTimeLabelFormats: {
            //   millisecond: '%H:%M:%S.%L',
            //   second: '%H:%M:%S',
            //   minute: '%H:%M',
            //   hour: '%H:%M',
            //   day: '%Y-%m-%d',
            //   week: '%m-%d',
            //   month: '%Y-%m',
            //   year: '%Y'
            // }
          },
          yAxis: {
            title: {
              text: '访问'
            }
          },
          legend: {
            enabled: false
          },
          plotOptions: {
            area: {
              fillColor: {
                linearGradient: {
                  x1: 0,
                  y1: 0,
                  x2: 0,
                  y2: 1
                },
                stops: [
                  [0, new Highcharts.getOptions().colors[0]],
                  [1, new Highcharts.Color(Highcharts.getOptions().colors[0]).setOpacity(0).get('rgba')]
                ]
              },
              marker: {
                radius: 2
              },
              lineWidth: 1,
              states: {
                hover: {
                  lineWidth: 1
                }
              },
              threshold: null
            }
          },
          series: [{
            type: 'area',
            name: '实时访问',
            data: [
              ['0:00', 50],



            ]
          }]
        },

        top_data: {}

      }

    },
    created() {

      // this.getHome();

      this.getTopData();
      this.getAccessData();


      // this.getAccessDay();

    },
    methods: {
      getHome() {
        this.httpPost({
          url: "/admin/home/home"
        }).then((re) => {
          console.log(re);
        });
      },
      getTopData() {

        this.httpPost({
          url: "/admin/data/data_top",
        }).then((re) => {

          console.log(re);

          this.top_data = re.data;

        })

      },
      getAccessData(){

        this.httpPost({
          url:"/admin/data/getAccess"
        }).then((re)=>{

          // console.log(re);

          this.access_option.series[0].data=re.data;


          // setTimeout(()=>{

          //   this.getAccessData();

          // },5000)

        });

      },

      getAccessDay(){


        this.httpPost({
          url:"/admin/data/getAccessDay"
        }).then((re)=>{

          console.log(re);

        });

      }

    }
  }
</script>

<style scoped>
  .data-m>div {

    margin-bottom: 10px;

  }
</style>



// WEBPACK FOOTER //
// src/components/home/Home.vue